import { render, staticRenderFns } from "./Richieste.vue?vue&type=template&id=0bedb922"
import script from "./Richieste.vue?vue&type=script&lang=js"
export * from "./Richieste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_2cae27f83758b46b73a9745eca16177c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports